export const REDUCER_NAME="themeSlice"

export interface iThemeForm {
    themeTitle?: string;
    themePrice?: string;
    description?: string;
    image?: (string | File)[];
    galleryImages?: string | File;
    zipFile?: File;
  }
  

  export interface iThemeResponse {
    id:string;
    authorId:string;
    themeTitle?: string;
    themePrice?: string;
    description?: string;
    image?:string;
    galleryImages?:Array<string>;
    zipFile?: File;
    previewUrl?: string;
  }

   export interface iThemeState {
      isLoading: boolean;
      themeList: iThemeResponse[];
      errorMessage: string | null;
    }